export default __webpack_public_path__ + "static/media/eggbox.645f6540.webp";